import React from 'react'

import { Portlet, Col, Row, Button } from '_zari/core'

import { IdGen } from 'utils'

import * as Tables from './tables'
import * as Modals from './modals'

const ListaDocumentosSection = ({ idTituloViatico, mostrarNuevoDocSection, mostrarNuevoSinDocSection }) => {
  const [__keyTabla, setKeyTabla] = React.useState(IdGen.newId())
  const [mostrarProcesarDocumentosModal, setMostrarProcesarDocumentosModal] = React.useState(false)

  const clickNuevoConDocumento = React.useCallback(() => {
    mostrarNuevoDocSection(null)
  }, [mostrarNuevoDocSection])

  const clickNuevoSinDocumento = React.useCallback(() => {
    mostrarNuevoSinDocSection(null)
  }, [mostrarNuevoSinDocSection])

  const clickProcesar = React.useCallback(() => {
    setMostrarProcesarDocumentosModal(true)
  }, [])

  const reloadTable = React.useCallback(() => {
    setKeyTabla(IdGen.newId())
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Lista de documentos' hideClose />
        <Portlet.Body>
          <Row className='mb-2'>
            <Col md={12} className='text-right'>
              <Button outline tiny onClick={clickNuevoConDocumento}>
                Nuevo con documento
              </Button>
              <Button outline tiny onClick={clickNuevoSinDocumento}>
                Nuevo sin documento
              </Button>
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={12}>
              <Tables.DocumentoTable
                key={__keyTabla}
                idTituloViatico={idTituloViatico}
                mostrarNuevoDocSection={mostrarNuevoDocSection}
                mostrarNuevoSinDocSection={mostrarNuevoSinDocSection}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} className='text-center'>
              <Button onClick={clickProcesar}>Procesar liquidación a registros de compras</Button>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
      {mostrarProcesarDocumentosModal && (
        <Modals.ProcesarDocumentosModal
          show={mostrarProcesarDocumentosModal}
          handleClose={() => setMostrarProcesarDocumentosModal(false)}
          idTituloViatico={idTituloViatico}
          reloadTable={reloadTable}
        />
      )}
    </>
  )
}

export default React.memo(ListaDocumentosSection)
